module.exports = __webpack_public_path__ + "img/waterColorCrop.153e0eac.jpg";